import { ChatLayout } from "../components/ChatLayout";
import { ChatPage as LegacyChatPage } from "./ChatPage.legacy";

const USE_ASSISTANT_UI = import.meta.env.VITE_USE_ASSISTANT_UI !== "false";

export const ChatPage = () => {
  if (!USE_ASSISTANT_UI) {
    return <LegacyChatPage />;
  }

  return <ChatLayout />;
};
